// Looping background music. Single shared HTMLAudioElement; survives view
// changes because it lives at module scope. Auto-ducks when TTS plays via
// the duck()/unduck() pair (call them around speech).
//
// Drop the source file at /public/music/tamburica.mp3. If missing, play()
// fails silently — the rest of the app keeps working.

const TRACK_URL = '/music/tamburica.mp3';
const DUCKED_FACTOR = 0.15;

let audio = null;
let enabled = true;
let userVolume = 0.5;
let duckDepth = 0; // nested duck() count, so overlapping speech doesn't unduck early
let userGestureBound = false;

function ensureAudio() {
  if (audio || typeof window === 'undefined') return audio;
  audio = new Audio(TRACK_URL);
  audio.loop = true;
  audio.preload = 'auto';
  audio.volume = userVolume;
  return audio;
}

function currentTargetVolume() {
  return duckDepth > 0 ? userVolume * DUCKED_FACTOR : userVolume;
}

function applyVolume() {
  if (audio) audio.volume = currentTargetVolume();
}

// iOS Safari and most mobile browsers block autoplay until the user
// interacts with the page. Bind a one-time gesture listener that retries
// play() — after that, future calls to start() succeed.
function bindFirstGesture() {
  if (userGestureBound || typeof window === 'undefined') return;
  userGestureBound = true;
  const retry = () => {
    if (enabled && audio && audio.paused) {
      audio.play().catch(() => {});
    }
    window.removeEventListener('pointerdown', retry);
    window.removeEventListener('touchstart', retry);
    window.removeEventListener('keydown', retry);
  };
  window.addEventListener('pointerdown', retry, { once: true });
  window.addEventListener('touchstart', retry, { once: true });
  window.addEventListener('keydown', retry, { once: true });
}

export function start() {
  if (!enabled) return;
  const a = ensureAudio();
  if (!a) return;
  applyVolume();
  const p = a.play();
  if (p && typeof p.catch === 'function') {
    p.catch(() => bindFirstGesture());
  }
}

export function stop() {
  if (audio) {
    audio.pause();
    audio.currentTime = 0;
  }
}

export function setEnabled(value) {
  enabled = Boolean(value);
  if (enabled) start();
  else stop();
}

export function setVolume(value) {
  userVolume = Math.max(0, Math.min(1, Number(value) || 0));
  applyVolume();
}

export function duck() {
  duckDepth += 1;
  applyVolume();
}

export function unduck() {
  duckDepth = Math.max(0, duckDepth - 1);
  applyVolume();
}
